<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-12 10:08:53
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-07-12 10:20:33
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/auditHistoryInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 审核历史 -->
<template>
  <div>
    <e-table-list :table-data="tableData" :table-label="tableLabel">
    </e-table-list>
  </div>
</template>

<script>
import eTableList from '../../../../components/common/e-table-list.vue';
import Api from '@/modules/projectA/api/ESorganization/index';

export default {
  props: {
    // 1: 评价机构企业信息审核,2:报告审核
    type: {
      type: String,
      default: ''
    },
    applyId: {
      type: Number,
      default: 0
    },
    // 单元分项id集合
    applyItemPriceIds: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    const tableLabel = [
      { label: '审核人', param: 'approver', align: 'center' },
      { label: '审核机构', param: '', align: 'center' },
      { label: '审核时间', param: 'approvalTime', align: 'center' },
      { label: '审核结果', param: 'resultDesc', align: 'center' },
      { label: '审核意见', param: 'reson', align: 'center' }
    ];
    if (this.type === '1') {
      tableLabel.splice(1, 1);
    }
    if (this.type === '2') {
      tableLabel[0].param = 'auditName';
      tableLabel[1].param = 'type';
      tableLabel[2].param = 'createTime';
      tableLabel[4] = {
        label: '审核意见',
        param: 'remark',
        align: 'center',
        tooltip: true,
        minWidth: 160
      };
      tableLabel[1].render = ({ type }) => {
        switch (type) {
          case '12':
            return '易派客';
          case '14':
            return '评价机构';
          default:
            return '';
        }
      };
    }
    return {
      tableData: [],
      tableLabel
    };
  },

  components: { eTableList },

  computed: {},

  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      let params = {
        applyId: this.applyId,
        operationTypeList: [110, 114]
      };
      if (this.type === '1') {
        params = {
          applyId: this.$route.query.applyId,
          operationTypeList: ['108'] // 资料复审
        };
      }
      let result = {};
      if (this.type === '2') {
        result = await Api.queryEvaluationAuditLogs({
          associationId: this.$route.query.evaluationItemId,
          applyItemPriceIds: this.applyItemPriceIds,
          typeList: [12, 14]
        });
      } else {
        result = await Api.queryApplyOperationLogs(params);
      }
      if (result.code === '200') {
        this.tableData = [...result.data];
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
